<template>

    <div class="lightbox-overlay">
        <div class="lightbox-inner" @click.prevent="closeLayer">


            <div class="lightbox-content">
                <div class="lightbox-toolbar">
                    <button class="lightbox-button-close" @click.prevent="close">&times;</button>
                </div>


                <template v-if="media && media.type === 'image'">
                    <img :src="media.url">
                </template>

                <template v-if="media && media.type === 'video'">
                    <video controls autoplay>
                        <source :src="media.url" />
                    </video>
                </template>

            </div>


        </div>
    </div>
</template>

<script>
    import {LIGHTBOX_SET_VISIBLE} from "../store/mutations";

    export default {
        name: "Lightbox",
        computed: {
            media() {
                return this.$store.state.lightboxMedia;
            }
        },

        methods: {
            closeLayer(ev) {
                if(ev.target.classList.contains('lightbox-inner')) {
                    this.$store.commit(LIGHTBOX_SET_VISIBLE, false);
                }
            },

            close() {
                this.$store.commit(LIGHTBOX_SET_VISIBLE, false);
            }
        },

        mounted() {
            document.addEventListener('keyup', ev => {
                if(ev.keyCode === 27) {
                    this.close();
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .lightbox-overlay {
        z-index: 100000;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.85);
    }

    .lightbox-inner {
        display: flex;
        justify-content: center;
        align-items: center;


        width: 100vw;
        height: 100vh;

    }

    .lightbox-content {
        max-width: 80%;

        img, video {
            display: block;
            max-width: 100%;
            height: auto;
        }
    }

    .lightbox-toolbar {
        text-align: right;
        margin-bottom: 20px;
    }

    .lightbox-button-close {
        appearance: none;
        border: 0;
        outline: 0;
        background-color: transparent;

        font-size: 30px;
        color: #fff;
        font-weight: bold;
    }

</style>